import React from 'react';
import { Link } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  // const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-deepblue-950 text-gray-700 dark:text-gray-200 pt-12 pb-8 border-t border-gray-200 dark:border-deepblue-800">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Column 1: Logo and Tagline */}
          <div className="col-span-1">
            <Link to="/" className="text-xl font-lexend font-bold text-primary tracking-tight">
              <span className="text-dark dark:text-white">Fork</span>:it
            </Link>
            <p className="mt-2 text-sm leading-relaxed">
              Giving small businesses back their digital independence.
            </p>
          </div>

          {/* Column 2: About Us */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold uppercase tracking-wide mb-3">About Us</h3> {/* {t('footer.title1')} */}
            <ul className="space-y-2">
              <li>
                <Link to="/manifest" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-ocean-300 transition-colors no-underline">
                  Manifest
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-ocean-300 transition-colors no-underline">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Offering */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold uppercase tracking-wide mb-3">Our Offer</h3> {/* {t('footer.title2')} */}
            <ul className="space-y-2">
              <li>
                <Link to="/solutions" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-ocean-300 transition-colors no-underline">
                  Solutions
                </Link>
              </li>
              <li>
                <Link to="/for-whom" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-ocean-300 transition-colors no-underline">
                  For Whom
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Participate */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold uppercase tracking-wide mb-3">Get Involved</h3> {/* {t('footer.title3')} */}
            <ul className="space-y-2">
              <li>
                <Link to="/become-a-partner" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-ocean-300 transition-colors no-underline">
                  Become a Partner
                </Link>
              </li>
              <li>
                <Link to="/your-story" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-ocean-300 transition-colors no-underline">
                  Share Your Story
                </Link>
              </li>
              <li>
                <Link to="/waitlist" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-ocean-300 transition-colors no-underline">
                  Join Waitlist
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-ocean-300 transition-colors no-underline">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section with legal links */}
        <div className="border-t border-gray-200 dark:border-deepblue-800 mt-8 pt-8 flex flex-col md:flex-row justify-between">
          <div className="text-xs text-gray-500 dark:text-gray-400">
            &copy; {currentYear} Fork:it. All rights reserved.
          </div>
          <div className="mt-4 md:mt-0 flex space-x-4">
            <Link to="/imprint" className="text-xs text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-ocean-300 transition-colors no-underline">
              Imprint
            </Link>
            <Link to="/privacy-policy" className="text-xs text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-ocean-300 transition-colors no-underline">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 